export const productShortName = 'Data Center Critical Power & Infrastructure — Professional Edition™';
export const productBrand = 'Data Center Critical Power & Infrastructure';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/9fjJnsixQunBsNTLAvUsGZ/MOCKUP_DATA_CENTER.png';
export const productImageAlt =
  'Data Center Critical Power & Infrastructure Professional Edition: six volumes covering fundamentals, critical power distribution, UPS and batteries, standby power, cooling and operations, plus five bonus resources';

export const checkoutUrl = 'https://data-center-critical-power-infrastructure-professional-edition.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about how power flows through a data center',
  'No more uncertainty about UPS, generators and transfer systems',
  'No more gaps in understanding cooling and airflow',
  'No more improvising maintenance and safety procedures',
  'No more walking into technical interviews unprepared',
];
